module.exports = __webpack_public_path__ + "img/abnormal.1a5f61f9.png";